"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var styles = {
  "container": "detail-list-container-UGFYb",
  "item": "detail-list-item-fKhWL",
  "header": "detail-list-header-2U2_U",
  "content": "detail-list-content-2vHo0"
};

var DetailList = _react.default.memo(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      passProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "className"]);
  return _react.default.createElement("ul", (0, _extends2.default)({
    className: _utils.classNames.use(styles.container).join(className)
  }, passProps), children);
});

var DetailItem = _react.default.memo(function (_ref2) {
  var name = _ref2.name,
      className = _ref2.className,
      children = _ref2.children,
      passProps = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["name", "className", "children"]);
  return _react.default.createElement("li", (0, _extends2.default)({
    className: _utils.classNames.use([styles.item]).join(className)
  }, passProps), _react.default.createElement("div", {
    className: styles.header
  }, name), _react.default.createElement("div", {
    className: styles.content
  }, children));
});

DetailList.Item = DetailItem;
var _default = DetailList;
exports.default = _default;